import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { DashboardSidebar } from '../DashboardSidebar';
import { DashboardContainer } from './styles';
import { useSidebar } from '../../contexts/SidebarContext/hook';
import { CasesProvider } from '@frontend/features/cases/components/CaseContext';
import { WhatsappClientProvider } from '@frontend/features/whatsapp/components/WhatsappClientContext';
import { DASHBOARD_MOBILE_NAV_HEIGHT, HEADER_HEIGHT } from '@frontend/features/common/constants/layout';
import { DashboardMobileNavigation } from '../DashboardMobileNavigation';

// FIXME: remove children prop
interface DashboardLayoutProps {
  children?: JSX.Element;
}

export const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const { isOpen, headerHeight } = useSidebar();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <WhatsappClientProvider>
      <CasesProvider>
        <Box bgcolor="paper.dark" minHeight="100vh" display="flex" flexDirection="column" alignItems="flex-end">
          {!isMobile && <DashboardSidebar />}
          <DashboardContainer
            isSidebarOpen={isOpen}
            sx={
              isMobile
                ? {
                  position: 'fixed',
                  top: headerHeight ?? HEADER_HEIGHT,
                  bottom: DASHBOARD_MOBILE_NAV_HEIGHT,
                  left: 0,
                  width: '100%',
                  height: 'auto',
                  overflow: 'auto',
                  minWidth: 0,
                }
                : undefined
            }
          >
            {children || <Outlet />}
          </DashboardContainer>
          {isMobile && <DashboardMobileNavigation />}
        </Box>
      </CasesProvider>
    </WhatsappClientProvider>
  );
};
